import api from "../../config/api";

const state = {
    quote: {}
}
const mutations = {
    setQuote(state, payload) {
        state.quote = payload;
    }
};

const actions = {
    async fetchInspirationalQuote({ commit }, locationID) {
        try {
            const response = await api.post(`/managelocationajax`, {
                cmd: "getinspiration",
                locationid: locationID,
                type: "Page",
                maxLength: 350
            });
            commit('setQuote', response.data.output);
        }
        catch (e) {
            console.log('Error in fetching data', e);
        }
    },
}
const getters = {
    stQuoteData: state => state.quote,
}

export default {
    state,
    mutations,
    actions,
    getters
}